// extracted by mini-css-extract-plugin
export default {"mainModal":"Modal_mainModal__kfAV5","p_moduleBody":"Modal_p_moduleBody__9uOrS","Modal":"Modal_Modal__l50NJ"};